export const forBusiness_realEstate_features = [
	{
		icon: '✅',
		title: 'featuresData_title1',
		subItems: [
			{
				icon: '🔹',
				item: 'featuresData_itemsFor1_item1',
			},
			{
				icon: '🔹',
				item: 'featuresData_itemsFor1_item2',
			},
			{
				icon: '🔹',
				item: 'featuresData_itemsFor1_item3',
			},
		],
	},
	{
		icon: '✅',
		title: 'featuresData_title2',
		subtitle: 'featuresData_subtitle2',
	},
	{
		icon: '✅',
		title: 'featuresData_title3',
		subItems: [
			{
				icon: '🔹',
				item: 'featuresData_itemsFor3_item1',
			},
			{
				icon: '🔹',
				item: 'featuresData_itemsFor3_item2',
			},
			{
				icon: '🔹',
				item: 'featuresData_itemsFor3_item3',
			},
		],
	},
	{
		icon: '✅',
		title: 'featuresData_title4',
		subtitle: 'featuresData_subtitle4',
	},
];
